import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'company_leverage'

export const dataPointDefinition = {
  retracedId: 'company_leverage',
  name: 'Company Leverage',
  meta: {
    showUpdatedAt: true,
    tooltip:
      'This field is automatically filled if the data fields annual purchase volume and annual revenue are filled. The value is calculated with this formula: (annual purchase volume/annual revenue)',
  },
  autofill: true,
  fieldTypeId: 'NUMBER',
  type: 'TRANSACTIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
      updatedAt: {
        type: 'string',
        format: 'date-time',
        minLength: 1,
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 461,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const autofill = (value, customDataFn) => {
  let autoFillValue

  if (customDataFn) {
    const annualRevenue = customDataFn('annual_revenue')
    const annualPurchaseVolume = customDataFn('annual_purchase_volume')

    if (!annualRevenue || !annualPurchaseVolume) {
      return {
        value: null,
        updatedAt: null,
      }
    }
    const {year: revenueYear, unit: revenueUnit, value: revenueValue} = annualRevenue
    const {year: purchaseYear, unit: purchaseUnit, value: purchaseValue} = annualPurchaseVolume

    if (revenueYear === purchaseYear && revenueUnit === purchaseUnit) {
      autoFillValue = purchaseValue / revenueValue
    }
  }

  return {
    value: autoFillValue || value,
    updatedAt: new Date().toISOString(),
  }
}
